/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Already_In_Folder_ToastInputs */



/**
* | output |
* | --- |
* | "Some items are already in this folder" |
*
* @param {Explorer_Thumbnail_Already_In_Folder_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_already_in_folder_toast = /** @type {((inputs?: Explorer_Thumbnail_Already_In_Folder_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Already_In_Folder_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Certains elements sont deja dans ce dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige Elemente befinden sich bereits in diesem Ordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alcuni elementi sono già presenti in questa cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Некоторые элементы уже находятся в этой папке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algunos elementos ya están en esta carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此文件夹中已有一些项目。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このフォルダには既にいくつかのアイテムが入っています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस फोल्डर में पहले से ही कुछ आइटम मौजूद हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alguns itens já estão nesta pasta.")
	return /** @type {LocalizedString} */ ("Some items are already in this folder")
});